import {Component, OnInit} from '@angular/core';
import {ChecklistService} from '../services/checklist.service';
import {Checklist} from '../classes/checklist';
import {ConfirmDialogService} from '../services/confirm-dialog-service/confirm-dialog.service';
import {Router, RouterLink} from '@angular/router';
import {Routenames} from '../route-names.enum';
import {SortingComponent} from '../sorting.component';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatRipple} from "@angular/material/core";
import {SortingIconComponent} from "../sorting-icon.component";

@Component({
    selector: 'app-checklists',
    templateUrl: './checklists.component.html',
    styleUrls: ['./checklists.component.scss'],
    imports: [
        VvrIconComponent,
        RouterLink,
        MatTooltip,
        MatButton,
        MatRipple,
        SortingIconComponent,
        MatIconButton
    ]
})
export class ChecklistsComponent extends SortingComponent<Checklist> implements OnInit {

    constructor(
        private checklistService: ChecklistService,
        private router: Router,
        private confirmDialog: ConfirmDialogService
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(this.checklistService.list().subscribe(lists => {
            this.list.set(lists.data);
            this.sortList('number');
        }));
    }

    edit(checklist) {
        this.router.navigate([Routenames.checklistEdit, checklist.id]);
    }

    copy(event, checklist) {
        event.stopPropagation();
        this.router.navigate([Routenames.checklistEdit, 'new', {copy: checklist.id}]);
    }

    delete(event, checklist: Checklist) {
        event.stopPropagation();
        this.confirmDialog.confirm(
            'Inspectielijst verwijderen',
            `Weet u zeker dat u Inspectielijst '${checklist.name}' wilt verwijderen?`,
            'Verwijderen',
            'Behouden'
        ).then(() => {
            this.checklistService.delete(checklist.id).subscribe(() => {
                const index = this.list().indexOf(checklist);
                this.list().splice(index, 1);
            });
        }, () => {

        });
    }
}
